
import { common } from './common/fr';
import { products } from './products/fr';
import { pricing } from './pricing/fr';
import { solutions } from './solutions/fr';

export const fr = {
  ...common,
  ...products,
  ...pricing,
  ...solutions,
};
